import createReactComponent from '../createReactComponent';
export default createReactComponent('git-commit', 'GitCommit', [["path",{"d":"M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-9-3h6m6 0h6","key":"svg-0"}]]);